import type { LoginFlowState } from './types';

// Uses sessionStorage to restore login progress after page reload.
// State expires after 10 minutes to prevent stale OTP situations.

const LOGIN_FLOW_KEY = 'amalq_login_flow';
const LOGIN_FLOW_EXPIRY_MS = 10 * 60 * 1000;

export const saveLoginFlow = (
  state: Omit<LoginFlowState, 'timestamp'>
): void => {
  try {
    const data: LoginFlowState = { ...state, timestamp: Date.now() };
    sessionStorage.setItem(LOGIN_FLOW_KEY, JSON.stringify(data));
  } catch {
    // sessionStorage might be disabled - fail silently
  }
};

export const loadLoginFlow = (): LoginFlowState | null => {
  try {
    const stored = sessionStorage.getItem(LOGIN_FLOW_KEY);
    if (!stored) return null;

    const data: LoginFlowState = JSON.parse(stored);

    if (Date.now() - data.timestamp > LOGIN_FLOW_EXPIRY_MS) {
      sessionStorage.removeItem(LOGIN_FLOW_KEY);
      return null;
    }

    return data;
  } catch {
    return null;
  }
};

export const clearLoginFlow = (): void => {
  try {
    sessionStorage.removeItem(LOGIN_FLOW_KEY);
  } catch {
    // Fail silently
  }
};
